import dayjs from "dayjs";
import {
  QueryCondition,
  QueryOperation,
  SearchQuery,
} from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import _ from "lodash";
import { hasValue } from "../utils/string";
import { InputObject } from "../controls/default";
import { CompanyUser } from "../repository/data.default";
import { nameOf } from "../utils/typescript";

export interface UsersViewForm {
  readonly userName: string;
  readonly firstName: string;
  readonly middleName: string;
  readonly lastName: string;
  readonly dateOfBirth: string;
  readonly email: string;
  readonly emailConfirmed: boolean;
  readonly phoneNumber: string;
  readonly companyPhoneNumber: string;
  readonly company?: InputObject;
}

export const usersViewColumns: DataColumn[] = [
  {
    title: "Company Name",
    key: "companyName",
    width: 192,
    sort: true,
    fixed: "left",
  },
  {
    title: "User Name",
    key: "userName",
    width: 192,
    sort: true,
  },
  {
    title: "First Name",
    key: "firstName",
    width: 192,
    sort: true,
  },
  {
    title: "Middle Name",
    key: "middleName",
    width: 192,
    sort: true,
  },
  {
    title: "Last Name",
    key: "lastName",
    width: 192,
    sort: true,
  },
  {
    title: "Date Of Birth",
    key: "dateOfBirth",
    width: 128,
    format: "DD/MM/YYYY",
    sort: true,
  },
  {
    title: "Email",
    key: "email",
    width: 256,
    sort: true,
  },
  {
    title: "Phone",
    key: "phoneNumber",
    width: 192,
    sort: true,
  },
  {
    title: "Company Phone",
    key: "companyPhoneNumber",
    width: 192,
    sort: true,
  },
];

export function mapUsersViewQuery(values: UsersViewForm): SearchQuery {
  const conditions: QueryCondition[] = Object.entries(values)
    .filter(([key, value]) => hasValue(value))
    .map(([key, value]) => {
      switch (key) {
        case nameOf<UsersViewForm>("company"):
          return {
            field: nameOf<CompanyUser>("companyUid"),
            values: [(value as InputObject).value],
            operation: QueryOperation.Equal,
          };
        case nameOf<UsersViewForm>("userName"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<UsersViewForm>("firstName"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<UsersViewForm>("middleName"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<UsersViewForm>("lastName"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<UsersViewForm>("dateOfBirth"):
          return {
            field: key,
            values: [dayjs(value).format("YYYY-MM-DD")],
            operation: QueryOperation.Equal,
          };
        case nameOf<UsersViewForm>("email"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        // case nameOf<UsersViewForm>("emailConfirmed"):
        //   return {
        //     field: key,
        //     values: [value],
        //     operation: QueryOperation.StartsWith,
        //   };
        case nameOf<UsersViewForm>("phoneNumber"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        // case nameOf<UsersViewForm>("companyPhoneNumber"):
        //   return {
        //     field: key,
        //     values: [value],
        //     operation: QueryOperation.StartsWith,
        //   };
      }
    })
    .filter((f) => !!f) as QueryCondition[];

  return {
    conditions,
  };
}
